import { EMfaMethod } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type GetCompanyMFATypesResponse = IApiResponse<EMfaMethod[]>;

export const getCompanyMFATypes = (axios: IAxiosInstance) => {
  return async (options?: { email?: string }) => {
    const params = options?.email
      ? `?email=${encodeURIComponent(options.email)}`
      : "";
    const response = await axios.noRetry.get<GetCompanyMFATypesResponse>(
      `/api/getCompanyMFATypes${params}`
    );

    const { data, success } = response.data;
    if (!success) {
      throw new Error("Failed to get company MFA types");
    }
    return data;
  };
};
